"use client";

import type { ReactNode } from "react";

import { useEffect } from "react";

import { useTracking } from "@/src/infrastructure/plausible/Tracking";

export function Track404(): ReactNode {
  const tracking = useTracking();

  useEffect(() => {
    tracking("404");
  }, [tracking]);

  return null;
}
